import { Box, Button, ButtonGroup, Divider, Grid, ListItem, ListItemText, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React from 'react';
import { DataApi } from '../../../providers/api-provider';
import Dialog from './Dialog';
import { Loader, showError, showSuccess, simpleInputStateHandler } from './helpers';
import PlainTextareaInput from './PlainTextareaInput';
import SwitchInput from './SwitchInput';
export default class CampaignFieldNotes extends React.Component {
    static defaultProps = {
        id: 0,
        field: "",
        type: "",
        add: false,
        resolve: false,
        list: [],
        loading: false,
        onUpdate: (data) => { },
    }
    state = {
        showAll: false,
        addLoading: false,
        deleteLoading: false,
        resolveLoading: false,
        editId: false,
        showDialog: false,
        note: '',
    }
    /*
    -----------------------------------------------------------------------
    API Functions
    -----------------------------------------------------------------------
    */

    performPerformAddNotesAction = async () => {
        try {
            this.setState({ addLoading: true });
            const res = await DataApi.create('admin/campaign-field-notes', {
                note: this.state.note,
                field: this.props.field,
                campaign_id: this.props.id,
                type: this.props.type
            })
            this.setState({ addLoading: false, note: '' });
            this.props.onUpdate(res.data);
            showSuccess('Note posted and student has been notified!');
        } catch (e) {
            showError(e);
            this.setState({ addLoading: false });
        }
    }
    performResolveNotesAction = (id) => async () => {
        try {
            this.setState({ resolveLoading: id });
            const res = await DataApi.update('student/campaign-field-notes/' + id, {
                note: this.state.note,
                field: this.props.field,
                campaign_id: this.props.id,
                type: this.props.type,
            })
            this.setState({ resolveLoading: false, note: '' });
            const newList = this.props.list.slice();
            newList.splice(newList.findIndex(i => i.id === id), 1, res.data);
            this.props.onUpdate(newList);
            showSuccess('Note marked as resolved!');
        } catch (e) {
            showError(e);
            this.setState({ resolveLoading: false });
        }
    }
    performDeleteNotesAction = (id) => async () => {
        try {
            this.setState({ deleteLoading: id });
            await DataApi.delete('admin/campaign-field-notes/' + id)
            this.setState({ deleteLoading: false });
            const newList = this.props.list.slice();
            newList.splice(newList.findIndex(i => i.id === id), 1);
            this.props.onUpdate(newList);
            showSuccess('Note deleted');
        } catch (e) {
            showError(e);
            this.setState({ deleteLoading: false });
        }
    }
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */
    onChange = simpleInputStateHandler
    showNotesDialog = () => {
        this.setState({ showDialog: true })
    }
    hideNotesDialog = () => {
        this.setState({ showDialog: false })
    }
    renderNote = (item, key) => {
        return (
            <ListItem key={"item-" + key}>
                <ListItemText primary={item.note}
                    secondary={<Typography color="textSecondary">
                        {item.user.name} | posted {item.created_at_for_humans} {item.resolved_at_for_humans && '| resolved ' + item.resolved_at_for_humans}
                        <Box marginTop={1}>
                            {this.props.add && <ButtonGroup size="small" variant="outlined" disabled={this.state.deleteLoading}>
                                <Button onClick={this.performDeleteNotesAction(item.id)}>{this.state.deleteLoading === item.id ? <Loader size={30} /> : 'Delete'}</Button>
                            </ButtonGroup>}
                            {this.props.resolve && !item.resolved_at && <Button size="small" color='primary' variant="outlined" disabled={this.state.resolveLoading}
                                onClick={this.performResolveNotesAction(item.id)}>
                                {this.state.resolveLoading === item.id ? <Loader size={30} /> : 'Mark as resolved'}
                            </Button>}
                        </Box>
                    </Typography>}>

                </ListItemText>

            </ListItem>
        )
    }
    renderForm = () => {
        return (
            <Grid container >
                <Grid item xs={12} className='bmargin-sm'>
                    <Divider />
                </Grid>
                <PlainTextareaInput
                    width={12}
                    placeholder='Write here...'
                    value={this.state.note}
                    onChange={this.onChange('note')}
                    margin='none'
                    variant="outlined"
                />
                <Grid item xs={1} className='tmargin-5'>
                    <Button variant="contained" color='primary'
                        onClick={this.performPerformAddNotesAction}
                        disabled={this.state.addLoading || !this.state.note}>
                        {this.state.addLoading ? <Loader size={20} /> : (this.state.editId ? 'Update' : 'Add')}
                    </Button>
                </Grid>
            </Grid>
        )
    }
    renderNotes = (notes) => {
        if (!notes.length)
            return <Box><Alert >No notes yet...</Alert></Box>;
        return notes.map(this.renderNote);
    }
    render() {
        const { showAll, editId, showDialog } = this.state;
        const { list, add, loading, resolve } = this.props;
        const notes = list || [];
        const pendingNotes = notes.filter(i => !i.resolved_at);
        return (
            <div>
                <Button variant="outlined" size="small"
                    className={resolve && pendingNotes.length ? "blink-bg" : ""}
                    disabled={loading}
                    onClick={this.showNotesDialog}>
                    {loading ? <Loader size={20} /> : 'Notes (' + pendingNotes.length + ' Pending)'}
                </Button>
                <Dialog
                    show={showDialog}
                    title="Notes"
                    onClick={false}
                    triggerHide={this.hideNotesDialog}
                    contentPadding={true}
                    size="md"
                >
                    <SwitchInput
                        name="showAll"
                        value={showAll}
                        onChange={this.onChange('showAll')}
                        data={[{ id: false, name: 'Show Pending' }, { id: true, name: 'Show All' }]}

                    />
                    {this.renderNotes(showAll ? notes : pendingNotes)}
                    {add && this.renderForm()}
                </Dialog>
            </div>

        )
    }
}